import { Button, message, Popconfirm, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    ErrorItem,
    InputNumberItem,
} from "../../../../Components/Items";
import round2Decimals from "../../../../Components/round2Decimals";
import { CalculatorOutlined } from "@ant-design/icons";

const { Option } = Select

class RegistrarPago extends Component {
    formRef = React.createRef();

    state = {
        loading: false,
        total: 0,
        totalPagado: 0,
        nombreCorredor: ''
    };

    async componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.setState({ loading: true })
            await axios
                .post(
                    "registrosCarrera/datosParaPago",
                    { empresaId: this.props.empresaId, registroId: this.props.id },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    if (res.data.success === 2) {
                        this.setState({
                            total: res.data.registro.total,
                            totalPagado: res.data.registro.totalPagado,
                            nombreCorredor: res.data.nombreCorredor
                        })
                    } else {
                        message.error("Error no se encontro informacion para el registro");
                    }
                });


            this.setState({ loading: false })
        }

    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "registrosCarrera/registrarPago",
                {
                    ...values,
                    empresaId: this.props.empresaId,
                    registroId: this.props.id
                },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Pago registrado exitosamente");
                    this.cerrarModalRegistrarPago();
                } else if (res.data.success === 1) {
                    message.error(res.data.message ? res.data.message : "No se pudo registrar el pago");
                } else {
                    message.error("Sucedió un error y no se pudo registrar el pago");
                }
            })
            .catch((error) => {
                this.setState({ loading: false });
                message.error("Error al comunicarse con el servidor");
            });
    }

    cerrarModalRegistrarPago() {
        this.setState({ visible: false });
        this.props.cerrarModalRegistrarPago();
        if (this.formRef.current) {
            this.formRef.current.resetFields();
        }
    }

    render() {
        return (
            <ModalItem
                title="Registrar Pago"
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.cerrarModalRegistrarPago.bind(this)}
                width={800}
                paddingTop
            >
                <Form
                    ref={this.formRef}
                    name="modalRegistrarPago"
                    layout='vertical'
                    bottom={
                        <Popconfirm
                            title={"Seguro que quiere registrar el pago a nombre de " + this.state.nombreCorredor}
                            onConfirm={() => this.formRef.current.formRef.current.submit()}
                            okText="Ok"
                            cancelText="Cancelar"
                        >
                            <Button
                                type="primary"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                                loading={this.state.loading}
                            >
                                Registrar
                            </Button>
                        </Popconfirm>
                    }
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                    className='registro-carrera-form-conekta'
                >
                    <h2>{this.state.nombreCorredor}</h2>
                    <FormItem
                        label="Forma de Pago"
                        required
                        name="formaDePago"
                    >
                        <Select
                            placeholder="Selecciona una forma de pago"
                        >
                            <Option value={1}>Tajeta</Option>
                            <Option value={2}>Efectivo</Option>
                            <Option value={3}>Transferencia</Option>
                        </Select>
                    </FormItem>



                    <FormItem
                        label="Monto"
                        required
                        name="monto"
                        type='number'
                        max={round2Decimals(this.state.total - this.state.totalPagado)}
                    >
                        <InputNumberItem 
                            addonBefore={<CalculatorOutlined onClick={() => this.formRef.current.setFieldsValue({ monto: round2Decimals(this.state.total - this.state.totalPagado) })} />} 
                            placeholder={'Restante: ' + round2Decimals(this.state.total - this.state.totalPagado)} />
                    </FormItem>

                </Form>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(RegistrarPago);
